// Formats the visible item range, such as " 26 - 50 of 97 ".
export const itemIdxDisplayer = (
  perPage,
  pageNum,
  pageItemCount,
  totalItemCount
) => {
  let baseIdx = perPage * (pageNum - 1)
  let startIdx = totalItemCount > 0 ? baseIdx + 1 : baseIdx
  return ` ${startIdx} - ${baseIdx + pageItemCount} of ${totalItemCount} `
}
